// Host / path classification — the browser-side mirror of the backend Tenant
// resolver (api/lib/Tenant.php). It decides whether the current URL is the
// PLATFORM (the SaaS product site + console, e.g. skulkit.com / localhost) or a
// specific school's tenant space.
//
// Tenancy is PATH-based: on shared hosting every school shares the one apex host
// and TLS cert, so a school lives under a URL prefix — skulkit.com/school/{slug}
// — instead of a subdomain. The platform is anything NOT under /school/{slug}.

const RESERVED = ['www', 'app', 'api', 'admin', 'mail', 'billing', 'dashboard']
const TENANT_PREFIX = 'school'

export function rootDomain() {
  return process.env.VUE_APP_ROOT_DOMAIN || 'skulkit.com'
}

function sanitize(slug) {
  return slug.toLowerCase().replace(/[^a-z0-9-]/g, '') || null
}

// The tenant slug from the URL path (/school/{slug}/...), reading ONLY the path.
// Used to compute the router base, so it must never be swayed by a dev override.
function slugFromPath() {
  const segments = window.location.pathname.split('/').filter(Boolean)
  if (segments[0] === TENANT_PREFIX && segments[1]) {
    const slug = sanitize(segments[1])
    return slug && !RESERVED.includes(slug) ? slug : null
  }
  return null
}

// The tenant slug for the current context, or null on the platform. Honors a
// ?tenant= override for local dev (where the SPA isn't served under /school/).
export function currentTenantSlug() {
  const override = new URLSearchParams(window.location.search).get('tenant')
  if (override) {
    const slug = sanitize(override)
    return slug && !RESERVED.includes(slug) ? slug : null
  }
  return slugFromPath()
}

// Vue Router base for the current context: /school/{slug}/ inside a tenant space,
// else the app's configured base. Path-only (a ?tenant dev override keeps base /).
export function tenantBase() {
  const slug = slugFromPath()
  return slug ? `/${TENANT_PREFIX}/${slug}/` : process.env.BASE_URL || '/'
}

// Namespace localStorage per tenant so sessions on the shared origin don't bleed
// across schools (a kings login must not authenticate greenwood).
export function storageKey(name) {
  const slug = currentTenantSlug()
  return slug ? `t:${slug}:${name}` : name
}

export function isPlatformHost() {
  return currentTenantSlug() === null
}
